<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const route = useRoute();

const activeIndex = computed(() => {
  const index = props.items.findIndex(i => i.route === route.name);
  return index === -1 ? 0 : index;
});

const steps = computed(() =>
  props.items.map((item, index) => {
    const isActive = index === activeIndex.value;
    const isOver = index < activeIndex.value;
    return {
      ...item,
      index,
      isActive,
      isOver,
    };
  })
);
</script>

<!-- Phase 9.6: the steps of a new inbox in the kit's words (a narrow column of steps, kit tokens); same items
     contract and the same route-based active step. -->
<template>
  <ol class="m-0 list-none p-0">
    <li
      v-for="step in steps"
      :key="step.route"
      :aria-current="step.isActive ? 'step' : undefined"
      class="relative flex items-start gap-3 pb-6 last:pb-0 after:absolute after:start-3.5 after:top-8 after:h-[calc(100%-2rem)] after:w-px after:bg-polaris-border after:content-[''] last:after:hidden"
    >
      <span
        class="z-10 flex size-7 shrink-0 items-center justify-center rounded-full border border-solid type-polaris-caption font-medium"
        :class="
          step.isActive
            ? 'border-polaris-primary bg-polaris-primary text-polaris-primary-foreground'
            : step.isOver
              ? 'border-polaris-border bg-polaris-muted text-polaris-foreground'
              : 'border-polaris-border bg-polaris-card text-polaris-muted-foreground'
        "
      >
        <Icon v-if="step.isOver" icon="i-lucide-check" class="size-3.5" />
        <template v-else>{{ step.index + 1 }}</template>
      </span>
      <span class="grid min-w-0 gap-0.5 pt-1">
        <span
          class="type-polaris-label"
          :class="
            step.isActive
              ? 'text-polaris-foreground'
              : 'text-polaris-muted-foreground'
          "
        >
          {{ step.title }}
        </span>
        <span class="type-polaris-caption text-polaris-muted-foreground">
          {{ step.body }}
        </span>
      </span>
    </li>
  </ol>
</template>
